/**
 * Automotive panel widgets — camera.
 */
import { registerAutomotive } from '../../registryCore';
import { bool } from '../../helpers';
import { addPanelFrame, addPanelTitle, finishPanel, panelBounds, panelGroup, panelTheme, textAt, } from '../panelPrimitives';
registerAutomotive('rearViewCamera', function (props, app) {
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 140);
    var group = panelGroup(app, 'rearViewCamera', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    addPanelFrame(group, app, bounds, theme);
    var viewY = addPanelTitle(group, app, bounds, theme, 'Rear Camera');
    var viewH = pad + h - viewY - 4;
    group.add(app.roundedRect({
        x: pad,
        y: viewY,
        width: w,
        height: viewH,
        cornerRadius: 8,
        fill: '#020617',
        stroke: theme.ok,
        strokeWidth: 1.5,
        listening: false,
    }));
    var cx = pad + w / 2;
    var cy = viewY + viewH / 2 - 6;
    var camR = Math.max(18, Math.min(w, viewH) * 0.14);
    group.add(app.circle({
        x: cx - camR,
        y: cy - camR,
        radius: camR,
        fill: '#1e293b',
        stroke: theme.textMuted,
        strokeWidth: 1.5,
        listening: false,
    }), app.roundedRect({
        x: cx - camR * 0.55,
        y: cy - camR * 0.35,
        width: camR * 1.1,
        height: camR * 0.7,
        cornerRadius: 4,
        fill: '#334155',
        listening: false,
    }), app.circle({
        x: cx - camR * 0.2,
        y: cy - camR * 0.05,
        radius: camR * 0.22,
        fill: theme.accent,
        opacity: 0.8,
        listening: false,
    }));
    var bx = pad + w * 0.18;
    var by = viewY + viewH * 0.72;
    group.add(app.path({
        d: "M ".concat(bx, " ").concat(viewY + viewH - 8, " L ").concat(cx - 18, " ").concat(by, " L ").concat(cx + 18, " ").concat(by, " L ").concat(pad + w * 0.82, " ").concat(viewY + viewH - 8),
        stroke: theme.ok,
        strokeWidth: 2,
        listening: false,
    }));
    group.add(app.text({
        text: 'REVERSE',
        x: pad + w / 2,
        y: textAt(viewY + viewH - 10, 8),
        fontSize: 8,
        fontWeight: 'bold',
        fill: theme.ok,
        textAlign: 'center',
        listening: false,
    }));
    return finishPanel(group, props, bounds, { active: bool(props, 'active', true) });
});
